import { render, staticRenderFns } from "./DemographicsCongress.vue?vue&type=template&id=c425659a&"
import script from "./DemographicsCongress.vue?vue&type=script&lang=js&"
export * from "./DemographicsCongress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports